import { ResponsiveImage, SmallTitle } from '@sleepstation/components'
import { LinkBase } from '@sleepstation/components-base'
import { VLayout } from '@sleepstation/components-layouts'
import { borderTopRadius, padding } from '@sleepstation/style-api-helpers'
import {
  classStartsWith,
  classStartsWithDirectChild,
  mqPointerOnly,
  outset,
} from '@sleepstation/style-mixins'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const IMAGE_ASPECT_RATIO = 130 / 72

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Wrapper = styled(LinkBase)`
  text-decoration: none;
`

const Layout = styled(VLayout)`
  ${outset()}
  overflow: hidden;

  ${mqPointerOnly()} {
    &:hover {
      ${classStartsWith(`ResponsiveImage__Layout`)} {
        will-change: transform;
        transition: transform 0.25s ease-in-out;
        transform: scale3d(1.025, 1.025, 1);
      }
    }
  }

  > * {
    display: block;
    image-rendering: smooth;
    will-change: transform;
    width: 100%;
  }
`

const Footer = styled.footer`
  ${padding(0.5)}
`

const ImageWrapper = styled.div`
  overflow: hidden;
  ${borderTopRadius(0.5)}
  mask-image: radial-gradient(white, black);

  ${classStartsWithDirectChild(`ResponsiveImage__Layout`)} {
    transition: transform 0.25s ease-in-out;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const CardLink = ({
  imageUrl,
  imageAlt,
  linkLabel,
  linkUrl,
  trackingId,
  dataCy,
}) => (
  <Wrapper
    href={linkUrl}
    data-tr-testimonial-link={trackingId}
    data-cy={dataCy}
  >
    <Layout>
      <ImageWrapper>
        <ResponsiveImage
          aspectRatio={IMAGE_ASPECT_RATIO}
          src={imageUrl}
          alt={imageAlt}
        />
      </ImageWrapper>
      <Footer>
        <SmallTitle>{linkLabel}</SmallTitle>
      </Footer>
    </Layout>
  </Wrapper>
)

CardLink.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  trackingId: PropTypes.string.isRequired,
  dataCy: PropTypes.string,
}

CardLink.defaultProps = {
  dataCy: ``,
}

export default CardLink
